
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './introlesson.json';

const Introlesson = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Introduction lesson framework, icebreakers, and classroom English. B2 level grammar, vocabulary, and speaking practice."
            level="B1"
            title="Introductions"
            image="/Images/education1.webp"
            seoTitle="Free English Conversation Exercises: Introductions"
            seoDescription="Introduction lesson framework, icebreakers, and classroom English. B2 level grammar, vocabulary, and speaking practice."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Introlesson;


